import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { CONTRACT_PARTY_ROLES } from './constants';

/**
 * Validation schemas for the contract party filter options API.
 */

export const zodContractPartiesQueryParamsSchema = z.object({
  companyIds: z.array(z.uuid()).max(200).optional(),
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).prefault(0),
  partyRole: z.enum(CONTRACT_PARTY_ROLES),
  searchString: z.string().trim().optional(),
});

export const zodContractPartySchema = z.object({
  id: z.uuid(),
  name: z.string(),
});

export const zodContractPartiesResponseSchema = z.object({
  data: z.array(zodContractPartySchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  // The endpoint never counts the full result set, so nothing may derive a
  // total from this; kept tolerant so a cosmetic field can never fail the parse.
  totalCount: z.number().int().nullish(),
});
